"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddAreasModal = AddAreasModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var area_library_1 = require("../../../features/apis/area-library");
var loader_1 = require("../../loader");
var button_component_1 = require("../../ui/button-component");
var text_component_1 = require("../../ui/text-component");
function AddAreasModal(props) {
    var _this = this;
    var isOpen = props.isOpen, clientId = props.clientId, _a = props.excludeAreaLibraryIds, excludeAreaLibraryIds = _a === void 0 ? [] : _a, _b = props.isSubmitting, isSubmitting = _b === void 0 ? false : _b, onClose = props.onClose, onAdd = props.onAdd;
    var _c = (0, area_library_1.useGetAreaLibrariesQuery)({ clientId: clientId }, { skip: !isOpen || !clientId }), data = _c.data, isFetching = _c.isFetching;
    var excludeSet = (0, react_3.useMemo)(function () { return new Set(excludeAreaLibraryIds); }, [excludeAreaLibraryIds]);
    var availableTemplates = (0, react_3.useMemo)(function () { var _a; return ((_a = data === null || data === void 0 ? void 0 : data.content) !== null && _a !== void 0 ? _a : []).filter(function (library) { return !excludeSet.has(library.id); }); }, [data, excludeSet]);
    var _d = (0, react_3.useState)(new Set()), selectedIds = _d[0], setSelectedIds = _d[1];
    var _e = (0, react_3.useState)(""), error = _e[0], setError = _e[1];
    var requestTokenRef = (0, react_3.useRef)(0);
    var requestInFlightRef = (0, react_3.useRef)(false);
    (0, react_3.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var handleClose = function () {
        if (requestInFlightRef.current || isSubmitting) {
            return;
        }
        requestTokenRef.current += 1;
        setSelectedIds(new Set());
        setError("");
        onClose();
    };
    var toggleSelected = function (areaLibraryId) {
        setSelectedIds(function (prev) {
            var next = new Set(prev);
            if (next.has(areaLibraryId)) {
                next.delete(areaLibraryId);
            }
            else {
                next.add(areaLibraryId);
            }
            return next;
        });
    };
    var handleAdd = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (requestInFlightRef.current || isSubmitting) {
                        return [2 /*return*/];
                    }
                    setError("");
                    if (!selectedIds.size) {
                        setError("Select at least one area template.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onAdd(Array.from(selectedIds))];
                case 2:
                    _b.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    requestInFlightRef.current = false;
                    handleClose();
                    return [2 /*return*/];
                case 3:
                    _a = _b.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError("Unable to add these areas. Please try again.");
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isSubmitting, isKeyboardDismissDisabled: isSubmitting, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[480px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isSubmitting, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", color: "dark-gray-1", weight: "bold", label: "Add Areas" }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1 flex flex-col gap-3", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm text-medium-gray", children: "Choose which area templates to add to this facility." }), isFetching ? ((0, jsx_runtime_1.jsx)("div", { className: "py-6", children: (0, jsx_runtime_1.jsx)(loader_1.Loader, { variant: "inline", size: "sm", label: "Loading area templates" }) })) : availableTemplates.length === 0 ? ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-2 py-6 text-center", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:widget-linear", fontSize: 28, className: "text-medium-gray" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-medium-gray", children: "No more area templates available to add." })] })) : ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-2 max-h-72 overflow-y-auto", children: availableTemplates.map(function (library) { return ((0, jsx_runtime_1.jsxs)(react_1.Checkbox, { isSelected: selectedIds.has(library.id), onChange: function () { return toggleSelected(library.id); }, className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Checkbox.Control, { children: (0, jsx_runtime_1.jsx)(react_1.Checkbox.Indicator, { children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:check-read-linear", fontSize: 12 }) }) }), (0, jsx_runtime_1.jsx)(react_1.Checkbox.Content, { children: library.name })] }, library.id)); }) })), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", onPress: handleClose, isDisabled: isSubmitting, variant: "secondary" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Add Areas", onPress: handleAdd, isPending: isSubmitting, isDisabled: !selectedIds.size, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
